import React, { useRef, useState} from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../mensajes2";
import { Dimmer } from "../../spinner";
import axios from "axios";
import {
  formatMoneda,
  validaMonto,
} from "../../../util/varios";
import { DangerButton, SuccessButton } from "../../../ui/buttons/Button";
import { Input, Textarea } from "../../../ui/inputs/Input";

export const ClasificadorRS = (props) => {
  const btnCancela = useRef();
  const txtId = useRef();
  const txtCodOr = useRef();
  const txtDescripcion = useRef();
  const txtMontoUni = useRef();
  const [activate, setActivate] = useState(false);
  const [operacion, setOperacion] = useState();
  const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

  let op = require("../../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const handleInputMontoChange = (event) => {
    validaMonto(event);
    if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
      event.target.value = '0,00'
    }
    if (event.which >= 37 && event.which <= 40) {
        event.preventDefault();
    }


    // Devuelve el número formateado
    let e = event.target.value.replace(/\D/g, "")
        .replace(/([0-9])([0-9]{2})$/, '$1.$2')
        .replace(/\B(?=(\d{3})+(?!\d)\.?)/g, ",");

        return formatMoneda(e) 
};

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });

    if (
      mensaje.texto == "registro creado correctamente." ||
      mensaje.texto == "registro modificado correctamente." ||
      mensaje.texto == "registro eliminado correctamente."
    ) {
      blanquearCampos();
      props.onHideCancela();
    }
  };

  const onChange = (event) => {
    if (event.target.name === "inputDescripcion") {
      event.target.value = event.target.value.toUpperCase();
    }
  };

  const selectClas = (operacion) => {
    let endpoint = `${op.conexion}/api/aseo/createclasificacion/${operacion}`;
    let body;
    setActivate(true);

    body = {
      nid: parseInt(txtId.current.value),
      cod: txtCodOr.current.value,
      descr: txtDescripcion.current.value,
      val: txtMontoUni.current.value.trim().replace(/\./g, "").replace(",", "."),
      tipo: 1,
    };

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
      })
      .then(function (response) {
        if (response.status == 200) {
          props.onHideRenderizar();
          if (props.operacion === 1) {
            setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro creado correctamente.', icono: 'exito' });
          } else if (props.operacion === 2) {
            setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro modificado correctamente.', icono: 'exito' });
          } else if (props.operacion === 3) {
            setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'registro eliminado correctamente.', icono: 'exito' });
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({ mostrar: true, titulo: 'ERROR', texto: error.response.data.message, icono: 'error' });
        setActivate(false);
      });
  };

  const validar = (e) => {
    e.preventDefault();
    var sigue = true;
    if (operacion !== 4) {
      if (
        txtCodOr.current.value === "" ||
        txtDescripcion.current.value === "" ||
        txtMontoUni.current.value === ""
      ) {
        setMensaje({ mostrar: true, titulo: 'ERROR', texto: 'Debe llenar correctamente todo lo campos', icono: 'error' });
        sigue = false;
      } else if (sigue === true) {
        selectClas(props.operacion);
      }
    }
  };

  const blanquearCampos = () => {
    setActivate(false);
    setOperacion();
    txtId.current.value = "";
    txtCodOr.current.value = "";
    txtDescripcion.current.value = "";
    txtMontoUni.current.value = "";
  };

  const salir = (e) => {
    props.onHideCancela();
    blanquearCampos();
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
      }}
    >
      <Modal.Header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">
          {operacion === 1
            ? "Agregar Códigos de Aseo Urbano."
            : operacion === 2
              ? "Editar Códigos de Aseo Urbano."
              : operacion === 3
                ? "Eliminar Códigos de Aseo Urbano."
                : "Códigos de Aseo Urbano de las Construcciones."}
        </h3>
        <a type="button"
          ref={btnCancela}
          className="fw-bold fs-6 text-light"
          onClick={salir}
        >
          Salir <i className="fa fa-times ms-2"></i>
        </a>
      </Modal.Header>
      <Modal.Body className="col-12 m-0 p-0 d-flex flex-wrap">
        <h2 className="col-12 m-0 p-0 text-center fw-bold">
          Clasificador de Aseo Urbano Según su Ordenanza
        </h2>
        <div class="col-3 m-0 p-0">
          <Input label = 'Código:'
            disabled
            ref={txtId}
            defaultValue={
              props.clasificador
                ? props.clasificador.idclaseaseo !== null
                  ? props.clasificador.idclaseaseo.trim()
                  : ""
                : ""
            }
            id="inputId"
            name="inputId"
          />
        </div>
        <div class="col-5 m-0 p-0 pl-2">
          <Input label = 'Código Segun Ordenanza:'
            ref={txtCodOr}
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            defaultValue={
              props.clasificador
                ? props.clasificador.codigoordenanza !== null
                  ? props.clasificador.codigoordenanza.trim()
                  : ""
                : ""
            }
            id="inputCodOr"
            name="inputCodOr"
          />
        </div>
        <div class="col-12 m-0 p-0">
          <Textarea label = 'Descripción:'
            style={{ height: 70 }}
            ref={txtDescripcion}
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            defaultValue={
              props.clasificador
                ? props.clasificador.descripcion !== null
                  ? props.clasificador.descripcion.trim()
                  : ""
                : ""
            }
            id="inputDescripcion"
            name="inputDescripcion"
            onChange={onChange}
          />
        </div>
        <div class="col-4 m-0 ml-auto p-0">
          <Input label = 'Monto de la Unidad:'
            ref={txtMontoUni}
            disabled={
              operacion === 1 ? false : operacion === 2 ? false : true
            }
            defaultValue={
              props.clasificador
                ? props.clasificador.monto !== null
                  ? formatMoneda(
                    props.clasificador.monto
                      .replace(",", "")
                      .replace(".", ","),
                    ",",
                    ".",
                    2
                  )
                  : ""
                : ""
            }
            id="inputMontoUni"
            onKeyUp={handleInputMontoChange}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <SuccessButton
          onClick={validar}
        >
          Aceptar
        </SuccessButton>
        <DangerButton
          ref={btnCancela}
          onClick={salir}
        >
          Cancelar
        </DangerButton>
      </Modal.Footer>
      <Mensaje mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === 'Exito.' ?
            cerrarModal() :
            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
        }
        } />
      <Dimmer active={activate} >
      </Dimmer>
    </Modal>
  );
};
